import { Link, useLocation } from "react-router-dom"

import { AuthPageShell } from "@/components/AuthPageShell"
import { Button } from "@/components/ui/button"
import { useAuth } from "@/lib/auth"

export function ForbiddenPage() {
  const { signOut } = useAuth()
  const location = useLocation()
  const state = location.state as { message?: string; status?: number } | null
  const authFailed = state?.status === 401

  return (
    <AuthPageShell>
      <div className="space-y-4">
        <h1 className="text-2xl font-semibold tracking-tight">
          {authFailed ? "Could not verify your session" : "Staff access required"}
        </h1>
        <p className="text-sm text-muted-foreground">
          {authFailed ? (
            <>
              The API rejected this token. For current Supabase access tokens (ES256), set{" "}
              <code className="text-foreground">SUPABASE_URL</code> in{" "}
              <code className="text-foreground">haute-api/.env</code> (same project URL as HO Kitchen) and
              restart the API. <code className="text-foreground">SUPABASE_JWT_SECRET</code> alone only
              verifies older HS256 tokens.
            </>
          ) : (
            <>
              Sign-in worked, but this user is not staff. In{" "}
              <code className="text-foreground">haute-api/.env</code> set{" "}
              <code className="text-foreground">STAFF_USER_IDS</code> to the Supabase Auth user UUID
              (Authentication → Users), then restart haute-api. HO Kitchen’s{" "}
              <code className="text-foreground">.env</code> does not read this variable.
            </>
          )}
        </p>
        {state?.message ? (
          <p className="rounded-md border border-border bg-card p-3 font-mono text-xs text-muted-foreground">
            {state.status ? `${state.status}: ` : null}
            {state.message}
          </p>
        ) : null}
        <div className="flex gap-2">
          <Button asChild variant="outline">
            <Link to="/login">Back to sign in</Link>
          </Button>
          <Button
            onClick={() => {
              void signOut()
            }}
            variant="ghost"
          >
            Sign out
          </Button>
        </div>
      </div>
    </AuthPageShell>
  )
}
